import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

export default function EmployeesSkeleton() {
    return (
        <div className="space-y-3">
            {Array.from({ length: 5 }).map((_, index) => (
                <Card key={index} className="p-4">
                    {/* Desktop */}
                    <div className="hidden md:grid grid-cols-[56px_2fr_1fr_1fr_1fr_1fr_40px] items-center gap-4">
                        <div className="flex justify-center">
                            <Skeleton className="h-10 w-10 rounded-full" />
                        </div>

                        <div className="space-y-2">
                            <Skeleton className="h-4 w-[60%]" />
                            <Skeleton className="h-3 w-[45%]" />
                        </div>

                        <div className="space-y-2">
                            <Skeleton className="h-3 w-10" />
                            <Skeleton className="h-4 w-24" />
                        </div>

                        <div className="space-y-2">
                            <Skeleton className="h-3 w-16" />
                            <Skeleton className="h-4 w-28" />
                        </div>

                        <div className="space-y-2">
                            <Skeleton className="h-3 w-12" />
                            <Skeleton className="h-4 w-10" />
                        </div>

                        <div className="space-y-2">
                            <Skeleton className="h-3 w-16" />
                            <Skeleton className="h-4 w-24" />
                        </div>

                        <div className="flex justify-end">
                            <Skeleton className="h-9 w-9 rounded-lg" />
                        </div>
                    </div>

                    {/* Mobile */}
                    <div className="md:hidden space-y-3">
                        <div className="flex items-start justify-between gap-3">
                            <div className="flex items-center gap-3 min-w-0">
                                <Skeleton className="h-10 w-10 rounded-full shrink-0" />
                                <div className="min-w-0 space-y-2">
                                    <Skeleton className="h-4 w-40 max-w-[70vw]" />
                                    <Skeleton className="h-3 w-52 max-w-[80vw]" />
                                </div>
                            </div>
                            <Skeleton className="h-9 w-9 rounded-lg" />
                        </div>

                        <div className="grid grid-cols-2 gap-3">
                            {Array.from({ length: 4 }).map((__, i) => (
                                <div key={i} className="space-y-2">
                                    <Skeleton className="h-3 w-16" />
                                    <Skeleton className="h-4 w-24" />
                                </div>
                            ))}
                        </div>
                    </div>
                </Card>
            ))}
        </div>
    );
}
